module.exports = __webpack_public_path__ + "media/gallery-wedding.3ea78625.webm";